/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React from 'react';
import PropTypes from 'prop-types';
import Screen from '../Screen';
import Comment from '../../Comment/Comment';
import Fab from '../../Fab/Fab';
import Dialog from '../../Dialog/Dialog';
import Attributeview from '../../Attributeview/Attributeview';
import Service from '../../Util/Service';
import $ from '../../Util/Util';
import AddIcon from './baseline_add_white_24dp.png';
import './Attributes.css';

/**
 * Represents the attribute maintenance screen.
 */

export default class Attributes extends Screen {

    /**
     * Properties.
     */

    static propTypes = {
        onAttributeSelected:         PropTypes.func.isRequired
    }

    /**
     * Default state.
     */

    state = {
        attributes:         [],
        selected:           null
    }

    /**
     * Loads all of the attributes.
     */

    _loadAttributes = () => {

        // Showing the progress indicator

        this.props.onLoading(true);

        // Loading attributes

        Service.loadAttribute().then((attributes) => {

            // Storing the attributes

            this.setState({ attributes : attributes });

            // Hiding the progress indicator

            this.props.onLoading(false);
        }).catch((error) => {

            // Hiding the progress indicator

            this.props.onLoading(false);

            // Showing error

            $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });
        });
    }

    /**
     * Event that fires when the user wants to add a new attribute.
     */

    _addAttribute = () => {

        // Clearing the selected attribute

        this.setState({ selected: null });

        // Opening the attribute maintenance dialog/screen

        if (this.props.context.environment.browser.info.mobile) {
            this.props.onAttributeSelected();
        } else {
            this.modifydialog.open();
        }
    }

    /**
     * Event that fires when the user wants to modify an attribute.
     * 
     * @param   {Object}    attribute   selected attribute
     */

    _modifyAttribute = (attribute) => {

        // Storing the selected attribute

        this.setState({ selected: attribute });

        // Opening the attribute maintenance dialog/screen

        if (this.props.context.environment.browser.info.mobile) {
            this.props.onAttributeSelected(attribute);
        } else {
            this.modifydialog.open();
        }
    }

    /**
     * Event that fires when the user cancels an attribute maintenance.
     * 
     * @param   {Boolean}   changed     attributes are changed or not
     */

    _closeModifyDialog = (changed) => {

        // Closing attribute maintenance dialog

        if (!this.props.context.environment.browser.info.mobile) {
            this.modifydialog.close();
        }

        // Loading attributes

        if (changed) {
            this._loadAttributes();
        }
    }

    /** 
     * Event that fires when the screen mounted.
     */

    componentDidMount() {

        // Setting actionbar title

        this.props.onSetActionbarTitle(this.props.context.locale.attribute.title.maintitle);

        // Loading attributes

        this._loadAttributes();
    }

    /** 
     * Attribute maintenance screen renderer.
     */

    render() {
        return (
            <div className="attributes" style={{ height: this.props.context.environment.screen.usefullheight + 'px'}}>

                {/* Attributes container */}

                <div className="attributes-container">

                    {/* Comment */}

                    <div className="attributes-comment">
                        <Comment text={this.props.context.locale.attribute.comment} bottomgap={16} />
                    </div>

                    {/* Attribute list */}

                    <div className="attributes-list" style={{ height: (this.props.context.environment.screen.usefullheight - (this.props.context.environment.browser.info.mobile ? 116 : 56)) + 'px'}}>
                        { this.state.attributes.map((item) =>
                            <div key={item.id} className="attributes-attribute" style={{ width: (this.props.context.environment.screen.width - 48) + 'px'}} onClick={this._modifyAttribute.bind(this, item)}>{item.name}</div>
                        )}
                    </div>

                    {/* Add icon */}

                    <div className="attributes-fab">
                        <Fab icon={AddIcon} tooltip={this.props.context.locale.attribute.newattributetooltip} onTouch={this._addAttribute} />
                    </div>

                    {/* Dialog for attribute modification */}

                    { !this.props.context.environment.browser.info.mobile &&
                        <Dialog ref={c => {this.modifydialog = c;}} modal width={600} height={420} closetooltip={this.props.context.locale.attribute.closedialog}>
                            <Attributeview context={this.props.context} attribute={this.state.selected} onClose={this._closeModifyDialog} onLoading={this.props.onLoading} onReload={this._loadAttributes} />
                        </Dialog>
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/Attributes/Attributes.js